import React from 'react';
import PropTypes from 'prop-types';

import { LogEvent } from '@learningblocks/shared-components/lib/EventLogger';
import styles from './style.module.scss';
import { t } from 'i18next';

export function Content(props) {

  const groupBy = (values, keyFinder) => {
    // using reduce to aggregate values
    return values.reduce((a, b) => {
      // depending upon the type of keyFinder
      // if it is function, pass the value to it
      // if it is a property, access the property
      const key = typeof keyFinder === 'function' ? keyFinder(b) : b[keyFinder];
      
      // aggregate values based on the keys
      if(!a[key]){
        a[key] = [b];
      }else{
        a[key] = [...a[key], b];
      }
      
      return a;
    }, {});
  };

  const resetLeadPosition = () => {
    const thisObj = document.getElementById("PowerSupplyLead_1_" + (props.connect + 1));
    switch(props.connect) {
      case 0:
        thisObj.style.transform="translate3d(-22px, 130px, 0px) rotateZ(0deg)"
        break;
      case 1:
        thisObj.style.transform="translate3d(-7px, 150px, 0px) rotateZ(0deg)"
        break;
      case 2:
        thisObj.style.transform="translate3d(7px, 150px, 0px) rotateZ(0deg)"
        break;
      case 3:
        thisObj.style.transform="translate3d(22px, 130px, 0px) rotateZ(0deg)"
        break;
      default:
        thisObj.style.transform="translate3d(0,0,0) rotate(0)"
    }
  }

  const getAvailableMoves = (label) => {

    label = label.firstChild.innerText;
    switch(getHeldObjectType(props.type)) {
      case "Pipette":
        if(
          label === t("P2 Tips") ||
          label === t("P20 Tips") ||
          label === t("P200 Tips") ||
          label === t("P1000 Tips") ||
          label === t("Trash") ||
          label === t("Biohazardous Waste") ||
          label === t("Gel Electrophoresis Box") ||
          label === t("Pipette rack") ||

          label === t("A") ||
          label === t("B") ||
          label === t("C") ||
          label === t("D") ||

          label === t("LB Plate") ||
          label === t("LB/amp Plate") ||
          label === t("LB/amp/ara Plate") ||

          label === t("Red Dye") ||

          label === t("S1") ||
          label === t("S2") ||
          label === t("S3") ||

          label === t("pARA Plasmid (A)") ||
          label === t("pKAN-R Plasmid (K)") ||
          label === t("K+") ||
          label === t("K-") ||
          label === t("A+") ||
          label === t("A-") ||
          label === t("Buffer (2.5XB)") ||
          label === t("Distilled Water (dH₂0)") ||
          label === t("Restriction Enzymes (RE)") ||

          label === t("Ligation Buffer (5XB)") ||
          label === t("Distilled Water (dH₂O)") ||
          label === t("Digested pKAN-R (K+)") ||
          label === t("Digested pARA (A+)") ||
          label === t("DNA Ligase (LIG)") ||
          label === t("Balancing Tube") ||

          label === t("pKAN-R (K-)") ||
          label === t("pKAN-R (K+)") ||
          label === t("pARA (A-)") ||
          label === t("pARA (A+)") ||
          label === t("Ligated Plasmids (LIG)") ||
          label === t("Loading Dye (LD)") ||
          label === t("DNA Ladder (M)") ||
          label === t("gK−") ||
          label === t("gK+") ||
          label === t("gA−") ||
          label === t("gA+") ||
          label === t("gLIG") ||
          label === t("Luria Broth (LB)") ||
          label === t("pARA-R (R)") ||
          label === t("Competent Cells (CC)") ||
          label === t("P- Tube") ||
          label === t("P+ Tube") ||
          label === t("P-") ||
          label === t("P+") ||

          label === t("𝘌. 𝘤𝘰𝘭𝘪 (EC1)") ||
          label === t("𝘌. 𝘤𝘰𝘭𝘪 (EC2)") ||
          label === t("Elution Buffer (EB)") ||
          label === t("Lysis Buffer (LyB)") ||
          label === t("Binding Buffer (BB)") ||
          label === t("Wash Buffer (WB)") ||
          label === t("Column Equilibration Buffer (CEB)") ||
          label === t("RFP") ||
          label === t("SUPER") ||
          label === t("Cuvette 1" )||
          label === t("Cuvette 2") ||
          label === t("Cuvette 3") ||
          label === t("Cuvette 4") ||
          label === t("Glass Tube 1") ||
          label === t("Glass Tube 2") ||
          label === t("Glass Tube 3") ||
          label === t("Glass Tube 4") 
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "Solution":
        if(
          label === t("Microcentrifuge") ||
          label === t("Floating Tube Rack") ||
          label === t("Vortex") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "Gel":
        if(
          label === t("Gel Electrophoresis Box") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "PowerSupplyLead":
        if(
          label === t("Gel Electrophoresis Box Anode") ||
          label === t("Gel Electrophoresis Box Cathode") ||
          label === t("Power Supply Anode") ||
          label === t("Power Supply Cathode") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "Flask":
        if(
          label === t("Gel Electrophoresis Box") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "FloatingTubeRack":
        if(
          label === t("Freezer") ||
          label === t("Water Bath") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "CellSpreader":
        if(
          label === t("LB Plate") ||
          label === t("LB/amp Plate") ||
          label === t("LB/amp/ara Plate") ||
          label === t("Trash") ||
          label === t("Biohazardous Waste") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "LabTape":
        if(
          label === t("LB Plate") ||
          label === t("LB/amp Plate") ||
          label === t("LB/amp/ara Plate") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;

      case "Petridish":
        if(
          label === t("Refrigerator") ||
          label === t("Incubator") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "WasteCollectionJar":
        if(
          label === t("Chromatography Column") ||
          label === t("Pipette rack")
        ){
          return true;
        } else {
          return false;
        }
        // code block
        break;
      case "CuvetteSeal":
        if(
          label === t("Cuvette 1") ||
          label === t("Cuvette 2") ||
          label === t("Cuvette 3") ||
          label === t("Cuvette 4") 
           ){
            return true;
           } else {
            return false;
           }

      case "Cuvette":
      if(
        label.includes(t("Spectrophotometer"))
      ){
        return true;
      } else {
        return false;
      }

      case "Stopper":
        if(
          label === t("Glass Tube 1") ||
          label === t("Glass Tube 2") ||
          label === t("Glass Tube 3") ||
          label === t("Glass Tube 4") 
        ){
          return true;
        } else {
          return false;
        }

      case "Plant":
        if(
          label === t("Glass Tube 1") ||
          label === t("Glass Tube 2") ||
          label === t("Glass Tube 3") ||
          label === t("Glass Tube 4") 
        ){
          return true;
        } else {
          return false;
        }

      case "Box":
        if(
          label === t("Glass Tube 1") ||
          label === t("Glass Tube 2") ||
          label === t("Glass Tube 3") ||
          label === t("Glass Tube 4") 
        ){
          return true;
        } else {
          return false;
        }
      
      default:
        // code block
    }


  }

  const showTeleportBtns = () => {

    //Getting all pipette targets
    let btnArr = Array.from(props.targetList)

    btnArr.sort((a, b)=>{
      let aLabel = a.getElementsByClassName("label")[0];
      let bLabel = b.getElementsByClassName("label")[0];

      if(typeof aLabel === 'undefined'){
        return -1;
      }
      if(typeof bLabel === 'undefined'){
        return 1;
      }

      if(aLabel.innerText < bLabel.innerText) return -1;
      if(aLabel.innerText > bLabel.innerText) return 1;
      return 0;
    });

    btnArr = btnArr.filter(getAvailableMoves);

    btnArr = groupBy(btnArr, (elem)=>{
      return elem.id.split('_')[0]
    })

    return Object.keys(btnArr).map((key, index)=>{
      let groupedBtns = btnArr[key];
      return(
        <div style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          gap: "8px",
          paddingBottom: (Object.keys(btnArr).length - 1 !== index)?"8px":null,
          borderBottom: (Object.keys(btnArr).length - 1 !== index)?"1px solid #99B2C4":null,
          width: "100%",
          padding: "8px"
        }}>
          {
            groupedBtns.map(btn => {
              let label = btn.getElementsByClassName("label")[0];
              if(
                typeof label === 'object' &&
                typeof label.innerText !== 'undefined' &&
                label.innerText !== null &&
                label.innerText !== ""
              ){
                return(
                  <LogEvent
                    logEventProps={{
                      event_type: "sim_protocol_movemenu action",
                      event_schema: "moveMenuAction",
                      target: label.innerText
                    }}
                    actionProps={{ 
                      onMouseDown: {action: 'mousedown'}, 
                      onKeyDown: {action: 'keydown'}, 
                    }}
                    elementType="button"
                  >
                    <button
                    className={styles.button}
                    key={btn.id}
                    onKeyDown={ (e)=>{if(e.key === 'Enter' || e.key === ' ') teleportTo(btn, e)} }
                    onKeyUp={ (e)=>{if(e.key === 'Enter' || e.key === ' ') teleportTo(btn, e)} }
                    onMouseDown={(e) => {teleportTo(btn, e)}}
                    onMouseUp={(e) => {teleportTo(btn, e)}}
                    >
                      {(
                        label.innerText === "Pipette rack" &&
                        getHeldObjectType(props.type) !== "Pipette"
                      )?"Shelf":label.innerText}
                    </button>
                  </LogEvent>
                )
              } else {
                return null;
              }
              
            })
          }
        </div>
      )
    });
  }

  const getHeldObjectType = () => {
    let heldObjectType = null;
    switch(props.component) {
      case "micropipette":
        heldObjectType = "Pipette"
        break;
      case "gel":
        heldObjectType = "Gel"
        // code block
        break;
      case "power supply lead":
        heldObjectType = "PowerSupplyLead"
        // code block
        break;
      case "flask":
        heldObjectType = "Flask"
        // code block
        break;
      case "solution":
        heldObjectType = "Solution"
        // code block
        break;
      case "floating tube rack":
        heldObjectType = "FloatingTubeRack"
        // code block
        break;
      case "cell spreader":
        heldObjectType = "CellSpreader"
        // code block
        break;
      case "lab tape":
        heldObjectType = "LabTape"
        // code block
        break;
      case "petridish":
        heldObjectType = "Petridish"
        // code block
        break;
      case "waste collection jar":
        heldObjectType = "WasteCollectionJar"
        // code block
        break;
      case "cuvette lid":
        heldObjectType = "CuvetteSeal"
        break;
      case "stopper":
        heldObjectType = "Stopper"
        break;
      case "box":
        heldObjectType = "Box"
        break;
      case "plant":
        heldObjectType = "Plant"
        break;
      case "cuvette":
        heldObjectType = "Cuvette"
        break;
      default:
        // code block
    }
    return heldObjectType;
  }

  const teleportTo = (elem, e) => {
    if(e.keyCode !== 9){

      let targetData = props.calculatePosition(elem)
      targetData.elem = elem

      let type = props.type;
      let connect = props.connect;
      
      // Map irregular ids
      if(props.component === 'power supply lead'){
        type = "Power Supply Lead_1";
        connect = connect + 1;
      }
      if(props.component === 'flask'){
        type = "Flask";
      }
      if(props.component === 'solution'){
        type = "Solution";
      }
      if(props.component === 'petridish'){
        type = "Petridish";
      }
      // End - Map irregular ids
      
      const thisObj = document.getElementById(type.replaceAll(" ", "")+"_"+connect);

      // First update the held state to trigger the interactions
      if(e.type === 'mousedown' || e.type === 'keydown'){

        //Set held object in redux to this data:
        if(props.component === 'power supply lead'){
          props.setHeldObject({
            type: getHeldObjectType(props.type),
            id: 1,
            htmlObj: thisObj,
          })
        } else {
          props.setHeldObject({
            type: getHeldObjectType(props.type),
            id: props.connect,
            htmlObj: thisObj,
          })
        }

        //Change pipette's state to held = true
        if(props.component === 'micropipette'){
          props.setHeld({
            id: props.connect,
            held: true,
          });
        }
        //Change gel's state to held = true
        if(props.component === 'gel'){
          props.setGelHeld({
            id: props.connect,
            held: true
          })
        }
        
        //Change power leads state to held = true
        if(props.component === 'power supply lead'){
          props.setPowerSupplyLeadHeld({
            id: 1,
            index: props.connect,
            held: true,
          })
        }

        //Change flask's state to held = true
        if(props.component === 'flask'){
          props.setFlaskHeld({
            id: props.connect,
            held: true,
          })
        }

        //Change solution's state to held = true
        if(props.component === 'solution'){
          props.setSolutionHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change floating tube rack's state to held = true
        if(props.component === 'floating tube rack'){
          props.setFloatingTubeRackHeld({
            id: props.connect,
            held: true,
          })
        }

        //Change cell spreaders state to held = true
        if(props.component === 'cell spreader'){
          props.setCellSpreaderHeld({
            id: props.connect,
            held: true,
          })
        }

        //Change lab tape state to held = true
        if(props.component === 'lab tape'){
          props.setLabTapeHeld({
            id: props.connect,
            held: true,
          })
        }

        //Change petri dish state to held = true
        if(props.component === 'petridish'){
          props.setPetridishHeld({
            id: props.connect,
            held: true,
          })
        }

        //Change waste collection jar state to held = true
        if(props.component === 'waste collection jar'){
          props.setWasteCollectionJarHeld({
            id: props.connect,
            held: true,
          })
        }

      } else if(e.type === "mouseup" || e.type === "keyup") {
        
        if(elem.id === "PipetteRack_1"){
          // Reset position
          if(props.type === "Power Supply Lead"){
            resetLeadPosition();
          } else {
            thisObj.style.transform="translate3d(0,0,0) rotate(0)"
          }
        } else {
          props.teleport(thisObj, targetData)
        }

        //Change pipette's state to held = false
        if(props.component === 'micropipette'){
          props.setHeld({
            id: props.connect,
            held: false,
          });
        }

        //Change gel's state to held = false
        if(props.component === 'gel'){
          props.setGelHeld({
            id: props.connect,
            held: false,
          });
        }

        //Change power leads state to held = true
        if(props.type === 'power supply lead'){
          props.setPowerSupplyLeadHeld({
            id: 1,
            index: props.connect,
            held: false,
          })
        }

        //Change flask's state to held = false
        if(props.component === 'flask'){
          props.setFlaskHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change solution's state to held = false
        if(props.component === 'solution'){
          props.setSolutionHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change floating tube rack's state to held = false
        if(props.component === 'floating tube rack'){
          props.setFloatingTubeRackHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change cell spreaders state to held = false
        if(props.component === 'cell spreader'){
          props.setCellSpreaderHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change lab tape state to held = false
        if(props.component === 'lab tape'){
          props.setLabTapeHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change petri dish state to held = false
        if(props.component === 'petridish'){
          props.setPetridishHeld({
            id: props.connect,
            held: false,
          })
        }

        //Change waste collection jar state to held = false
        if(props.component === 'waste collection jar'){
          props.setWasteCollectionJarHeld({
            id: props.connect,
            held: false,
          })
        }

        //Clear held object
        props.setHeldObject({
          type: null,
          id: -1,
          htmlObj: null,
        })

        props.toggleModal();
      }
    }
  }

  return (
    <div className={styles.move_menu_content}>
      {showTeleportBtns()}
    </div>
  );
}

Content.propTypes = {
};
Content.defaultProps = {
};
